// jQuery
window.$ = window.jQuery = require('jquery');

// Axios
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Bootstrap modal
require('bootstrap/js/dist/modal');
require('bootstrap/js/dist/popover');

// Menu
require('hoverintent');
require('superfish');

// Owl Carousel
require('owl.carousel');

// Parallax
require('stellar.js');

// In viewport //
require('is-in-viewport');

// Isotope
require('imagesloaded');
require('isotope-layout/dist/isotope.pkgd.min');

// Google Maps
require('gmap3');

// Animated Headlines
require('./animated-headlins');

// Infinite scroll
window.InfiniteScroll = require('infinite-scroll');
window.imagesLoaded = require('imagesloaded');

window.Cookies = require('js-cookie');

window.magnificPopup = require('magnific-popup');